module.exports = __webpack_public_path__ + "img/warrior.86d1441b.svg";